import React from 'react';

const ArrowLeftPagination = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="19"
      viewBox="0 0 12 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.986113 8.78838L9.28447 0.489878C9.47675 0.297999 9.73731 0.190308 10.009 0.190308C10.2806 0.190308 10.5412 0.297999 10.7334 0.489878L11.7013 1.4587C11.8929 1.65094 12.0004 1.9114 12.0004 2.18281C12.0004 2.45423 11.8929 2.71445 11.7013 2.9067L5.1241 9.51386L11.7013 16.1217C11.8926 16.3139 12 16.5739 12 16.8451C12 17.1163 11.8926 17.3766 11.7013 17.5688L10.7334 18.5376C10.5412 18.7295 10.2806 18.8372 10.009 18.8372C9.73731 18.8372 9.47675 18.7295 9.28447 18.5376L0.986113 10.2391C0.890822 10.1439 0.815228 10.0308 0.763655 9.9063C0.712081 9.78184 0.685547 9.64859 0.685547 9.51386C0.685547 9.37913 0.712081 9.24565 0.763655 9.12118C0.815228 8.99672 0.890822 8.88362 0.986113 8.78838Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowLeftPagination;
